import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

export default function City(props) {
  function handleChange(event) {
    let inputElement = document.getElementById(event.target.id);
    let errorElement = inputElement.nextSibling;
    if (event.target.value.trim().length === 0) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML = 'The City field should not be empty';
      errorElement.style.display = 'block';
    } else if (!/^[ a-zA-Z/-]+$/.test(event.target.value)) {
      inputElement.classList.add('is-invalid');
      errorElement.innerHTML = 'The City field should contain only letters';
      errorElement.style.display = 'block';
    } else {
      errorElement.style.display = 'none';
      inputElement.classList.remove('is-invalid');
    }
    props.onChange(event);
  }
  return (
    <>
      <Form.Group as={Row} controlId={props.id} className="mb-3">
        <Form.Label column sm={6} required>
          {props.label}
        </Form.Label>

        <Form.Control
          type="text"
          placeholder={props.label ? props.label : props.placeholder}
          maxLength="30"
          value={props.state[props.id] ? props.state[props.id] : ''}
          onChange={handleChange}
          pattern="^[A-Za-z\-\/ ]+$"
          onKeyPress={(event) => {
            if (!/[ a-zA-Z/-]/.test(event.key)) event.preventDefault();
          }}
          required
          data-hj-allow
          isInvalid={props.isInvalid}
        />
        <Form.Control.Feedback type="invalid">
          Please provide a city name
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
}
